var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomePaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 18,
    viewBox: "0 0 15.75 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-paperclip",
    "data-name": "Icon awesome-paperclip",
    d: "M1.52,16.388a5.508,5.508,0,0,1,.049-7.649L8.943,1.2a3.934,3.934,0,0,1,5.649,0,4.092,4.092,0,0,1,0,5.705L8.164,13.469a2.623,2.623,0,0,1-3.8-.035,2.725,2.725,0,0,1,.051-3.76L9.472,4.512a.563.563,0,0,1,.8-.008l.8.787a.562.562,0,0,1,.008.8L6.027,11.247A.475.475,0,0,0,6,11.89a.375.375,0,0,0,.552.006l6.428-6.569a1.841,1.841,0,0,0,0-2.559,1.686,1.686,0,0,0-2.431,0L3.178,10.311a3.256,3.256,0,0,0-.042,4.511,3,3,0,0,0,4.326.01l6.049-6.187a.563.563,0,0,1,.8-.009l.8.786a.562.562,0,0,1,.009.8L9.071,16.4a5.246,5.246,0,0,1-7.55-.017Z",
    transform: "translate(0 0)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomePaperclip);
export default __webpack_public_path__ + "static/media/Icon awesome-paperclip.9e9cf74ead20528303e5b1fe51bf6e60.svg";
export { ForwardRef as ReactComponent };